/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelLanguageSwitch = new Class({
  Extends: PanelOptions,
  hasSelectedLanguage: function () {
    return this.quriobot.getBotOption('hasSelectedLanguage')
  },
  template: function () {
    if (this.hasSelectedLanguage()) {
      var base = ''
      return { base: base, option: '' }
    }
    return PanelOptions.prototype.template.bind(this)()
  },
  populate: function (result) {
    if (this.hasSelectedLanguage()) {
      var base = this.template().base
      this.after()
      return base
    }
    var botData = this.quriobot.getBotOption('botData')
    this.data.options = botData.languages.map(function (item) {
      return {
        id: item.code,
        text: item.name,
      }
    })
    return PanelOptions.prototype.populate.bind(this)(result)
  },
  after: function () {
    var selectedLanguage = ''
    var selectedContent = ''
    if (this.element) {
      this.element.getElements('.panel--options__list')[0].set({
        'aria-disabled': true,
      })
      selectedLanguage = this.selected.values[0]
      selectedContent = this.selected.content[0]
      // quriobot.store.set(this.quriobot.getLangStorageKey(), selectedLanguage)
      this.element.addClass('isAnswered')
      this.quriobot.switch(null, selectedLanguage)
      // Add `aria-hidden="true"` after answering to the question
      this.setAriaHidden('.panel--options__list', true)

      // Remove `aria-hidden="true"` from redo-button
      this.setAriaHidden('.icon--redoWrapper', false)
    }
    var answerData = {
      answer: {
        render: false,
        value: selectedLanguage,
        content: selectedContent,
      },
    }
    this.answerCallback(this.data, answerData)
  },
})
